<ng-container *ngIf="displayTheme">
  <mat-toolbar class="sidemenu-toolbar">
    <i class="icon mdi mdi-palette"></i>
    <span class="title">Branding/Theming</span>
  </mat-toolbar>
        <mat-card class="example-card shadow-none rounded-0 border-bottom border-light">
          <mat-card-header>
            <mat-card-title class="mb-2">Themes</mat-card-title>
          </mat-card-header>
          <mat-card-content>

            <form [formGroup]="themeColors">
              
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Theme</mat-label>
                  <mat-select matNativeControl formControlName="themeName" required placeholder="Select Theme" (selectionChange)="onThemeChange($event)">
                    <ng-container *ngFor="let item of allThemes">
                      <mat-option [value]='item.theme_name'>{{item.theme_name}}</mat-option>
                    </ng-container>
                  </mat-select>
                </mat-form-field>
              <div class="theming-color-items">
                <div class="color-item" for="primaryColor">
                  <div class="content">
                    <div class="label">Primary</div>
                    <div class="value">{{getColorValue('primaryColor')}}</div>
                  </div>
                  <div [style.background-color]="getColorValue('primaryColor')" mat-ripple class="color-thumb">
                    <input type="color"  value="#000000" (input)="getChangedColorValue('primaryColor')" formControlName="primaryColor" id="primaryColor">
                  </div>
                </div>
                <div class="color-item" for="secondaryColor">
                  <div class="content">
                    <div class="label">On Primary</div>
                    <div class="value">{{getColorValue('secondaryColor')}}</div>
                  </div>
                  <div [style.background-color]="getColorValue('secondaryColor')" mat-ripple class="color-thumb">
                    <input type="color" value="#000000" (input)="getChangedColorValue('secondaryColor')" formControlName="secondaryColor" id="secondaryColor">
                  </div>
                </div>
                <div class="color-item" for="defaultBackgroundColor">
                  <div class="content">
                    <div class="label">Background Color</div>
                    <div class="value">{{getColorValue('defaultBackgroundColor')}}</div>
                  </div>
                  <div [style.background-color]="getColorValue('defaultBackgroundColor')" mat-ripple class="color-thumb">
                    <input type="color" value="#000000" (input)="getChangedColorValue('defaultBackgroundColor')" formControlName="defaultBackgroundColor" id="defaultBackgroundColor">
                  </div>
                </div>
                <div class="color-item" for="defaultTextColor">
                  <div class="content">
                    <div class="label">Body Text Color</div>
                    <div class="value">{{getColorValue('defaultTextColor')}}</div>
                  </div>
                  <div [style.background-color]="getColorValue('defaultTextColor')" mat-ripple class="color-thumb">
                    <input type="color" value="#000000" (input)="getChangedColorValue('defaultTextColor')" formControlName="defaultTextColor" id="defaultTextColor">
                  </div>
                </div>
              </div>
            </form>
          </mat-card-content>
        </mat-card>
      <mat-card class="example-card shadow-none rounded-0 border-bottom border-light">
        <mat-card-header>
          <mat-card-title class="mb-2">Fonts</mat-card-title>
        </mat-card-header>
        <mat-card-content>
      <form [formGroup]="postFontData" class="mat-form-field-container">
        <mat-form-field appearance="outline">
          <mat-label>Headings</mat-label>
          <mat-select matNativeControl formControlName="headingFont" required placeholder="Select Heading Font" (selectionChange)="onHeadingFontChange($event)">
            <ng-container *ngFor="let item of fonts">
              <mat-option value={{item.font_heading}}>{{item.font_heading}}</mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Body</mat-label>
          <mat-select matNativeControl formControlName="bodyFont" required placeholder="Select Body Font" (selectionChange)="onBodyFontChange($event)">
            <ng-container *ngFor="let item of fonts">
              <mat-option value={{item.font_body}}>{{item.font_body}}</mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </form>
      </mat-card-content>
      </mat-card>
      <mat-dialog-actions *ngIf="cancelEnable" class="dailog-footer-buttons">
      <button  mat-raised-button (click)="revertBackTheme()">Reset</button>
      <button mat-raised-button color="primary" (click)="updateThemeData()">Apply</button>
    </mat-dialog-actions>
  </ng-container>
  
  <div *ngIf="spinnerActive" class="spinner-container">
    <mat-spinner diameter="35"></mat-spinner>  
  </div>